import React from 'react';
import ParagraphText from '../../../shared/ParagraphText';
import { useCompanyName } from '../../../shared/useCompanyName';

// "About {Company Name}" blurb (Company Settings > About Us) shown once
// under the title block on page 1 of both Pricelist reports. Renders
// nothing when the blurb is blank, so a tenant that hasn't filled it in
// sees no gap. Contact/social info (Instagram/Website/Phone/Email) lives
// separately in PricelistContactBlock.js, at the end of the Extended
// Pricelist rather than competing with page 1's product rows for room.
const EXTENDED_HEADING_STYLE = { fontSize: 14, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#3a6ea5', margin: '0 0 6px' };
// Same as PricelistCompactReport.js's category heading.
const COMPACT_HEADING_STYLE = { fontSize: 16, fontWeight: 700, margin: '0 0 10px', paddingBottom: 6, borderBottom: '2px solid #dde4ec' };

// `variant` picks the heading treatment of the report it sits in, so the
// About heading matches that report's category headings. `companyInfo` —
// see useCompanyName.js — threaded through for the server-rendered PDF
// attachment path (issue #238).
function PricelistAboutUs({ variant = 'extended', companyInfo }) {
  const { companyName, aboutUs } = useCompanyName(companyInfo);
  if (!aboutUs.trim()) return null;
  return (
    <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
      <h3 style={variant === 'compact' ? COMPACT_HEADING_STYLE : EXTENDED_HEADING_STYLE}>
        About {companyName}
      </h3>
      <ParagraphText text={aboutUs} style={{ fontSize: 13, color: '#666' }} />
    </div>
  );
}

export default PricelistAboutUs;
